// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__1DycV","row":"ProcedureTreatmentSummary_row__3vNzi"};